// services/api.js
const BASE_URL = "https://looptager.com/api/service1"; // Base URL

export const handleTransferApi = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send4`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};

export const handleTransferApi5to6 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send5`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi5to7 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send5to7`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi5to8 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send5to8`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi6to9 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send6to9`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi6to10 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send6to10`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi7to11 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send7to11`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi7to12 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send7to12`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi8to13 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send8to13`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const handleTransferApi8to14 = async (amount) => {
  try {
    if (!amount) {
      throw new Error("Please enter an amount.");
    }

    const numericAmount = parseFloat(amount.replace(/,/g, "")); // Remove commas before sending
    const response = await fetch(`${BASE_URL}/api/transactions/send8to14`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        amount: numericAmount,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error during transfer:", error);
    throw error;
  }
};
export const fetchFromAccounts = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/account-holders2`);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching from accounts:", error);
    throw error;
  }
};

export const fetchToAccounts = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/beneficiaries/all2`);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching to accounts:", error);
    throw error;
  }
};

export const fetchBank2AccountDetails = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/account-holders3/all`);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching Bank 2 account details:", error);
    throw error;
  }
};

export const fetchCount = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/tags/count-debit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ part1Value: '1B4B5' }),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return data.count;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};

export const fetchTimeTaken = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/tags/calculate-time-difference`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data.timeDifferenceInMinutes;
  } catch (error) {
    console.error('Error fetching Time Taken:', error);
    throw error;
  }
};

export const fetchTransactionDetails = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/transactions/atm/withdraw/default?amount=0`, {
      method: "POST", // POST request for getting the default transaction details
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return {
      accountNumber: data.accountNumber,
      availableBalance: data.availableBalance,
      nonTagAmount: data.nonTagAmount,
      totalTagAmount: data.totalTagAmount,
    };
  } catch (error) {
    console.error("Error fetching initial transaction details:", error);
    throw error;
  }
};

export const fetchAccountHolderDetails = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/account-holders2/all`);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    if (data.length > 0) {
      return {
        accountNumber: data[0].accountNumber,
        availableBalance: data[0].availableBalance,
      };
    }
  } catch (error) {
    console.error("Error fetching account details:", error);
    throw error;
  }
};

// Function to handle truncate operation
export const handleTruncateApi = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/maintenance/truncateAll`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();
    return result.status;
  } catch (error) {
    console.error("Error during truncate operation:", error);
  }
  return null;
};

// Function to handle insert operation
export const handleInsertApi = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/insert-data`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();
    return result.status1;
  } catch (error) {
    console.error("Error during insert operation:", error);
  }
  return null;
};
// Fetch count for debit
export const fetchCountApi = async () => {
  const response = await fetch(`${BASE_URL}/api/tags/count-debit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      part1Value: "1B4B5", // Hardcoded part1Value
    }),
  });

  if (!response.ok) {
    throw new Error("Failed to fetch count for debit.");
  }

  const data = await response.json();
  return data;
};

// Fetch time difference
export const fetchTimeDifferenceApi = async () => {
  //const response = await fetch(`${BASE_URL}/api/tags/calculate-time-difference`);
  const response = await fetch(`${BASE_URL}/api/timedifference`);

  if (!response.ok) {
    throw new Error("Failed to fetch time difference.");
  }

  const data = await response.json();
  return data;
};

export const fetchFailureCountApi = async (type) => {
  try {
    const requestBody = JSON.stringify({ amount: "10000000" });

    const response = await fetch(`${BASE_URL}/api/transactions/atm/withdraw5`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: requestBody,
    });

    if (!response.ok) {
      throw new Error("Failed to fetch failure count.");
    }

    const data = await response.json();
    return data; // Return the response data
  } catch (error) {
    console.error("Error fetching failure count:", error);
    throw error; // Re-throw the error for handling in the component
  }
};

export const fetchAnotherFailureCountApi = async () => {
  try {
    const requestBody = JSON.stringify({ amount: "10000000" });

    const response = await fetch(`${BASE_URL}/api/transactions/atm/withdraw9`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: requestBody,
    });

    if (!response.ok) {
      throw new Error("Failed to fetch another failure count.");
    }

    const data = await response.json();
    return data; // Return the response data
  } catch (error) {
    console.error("Error fetching another failure count:", error);
    throw error; // Re-throw the error for handling in the component
  }
};
// Function to call the failure count API for the second request (withdraw11 endpoint)
export const fetchAnotheroneFailureCountApi = async () => {
  try {
    const requestBody = JSON.stringify({ amount: "10000000" });

    const response = await fetch(`${BASE_URL}/api/transactions/atm/withdraw11`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: requestBody,
    });

    if (!response.ok) {
      throw new Error("Failed to fetch another one failure count.");
    }

    const data = await response.json();
    return data; // Return the response data
  } catch (error) {
    console.error("Error fetching another one failure count:", error);
    throw error; // Re-throw the error for handling in the component
  }
};
// Function to call the failure count API for withdraw13
export const fetchAnother13FailureCountApi = async () => {
  try {
    const requestBody = JSON.stringify({ amount: "10000000" });

    const response = await fetch(`${BASE_URL}/api/transactions/atm/withdraw13`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: requestBody,
    });

    if (!response.ok) {
      throw new Error("Failed to fetch failure count for withdraw13.");
    }

    const data = await response.json();
    return data; // Return the API response data
  } catch (error) {
    console.error("Error fetching failure count for withdraw13:", error);
    throw error; // Re-throw the error for handling in the component
  }
};
// Function to call the failure count API for withdraw14
export const fetchAnother14FailureCountApi = async () => {
  try {
    const requestBody = JSON.stringify({ amount: "10000000" });

    const response = await fetch(`${BASE_URL}/api/transactions/atm/withdraw14`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: requestBody,
    });

    if (!response.ok) {
      throw new Error("Failed to fetch failure count for withdraw14.");
    }

    const data = await response.json();
    return data; // Return the API response data
  } catch (error) {
    console.error("Error fetching failure count for withdraw14:", error);
    throw error; // Re-throw the error for handling in the component
  }
};

// Function to mark fraud with a specific part1 value
export const markFraud = async (part1Value) => {
  try {
    const response = await fetch(`${BASE_URL}/api/tags/mark-fraud`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ part1: part1Value }),
    });

    if (response.ok) {
      const data = await response.json();
      return data; // Return the API response data
    } else {
      console.error("Error marking fraud");
      return null;
    }
  } catch (error) {
    console.error("Error occurred while calling API:", error);
    return null;
  }
};
// Function to submit a transaction
export const submitTransaction = async (formData, getCleanedAmount, setResponseMessage, setTransferredAmount, setTransactionDetails, setBox1Data, setBox2Data, setTransactionSubmitted, setReferenceNumber) => {
  try {
    const payload = {
      remitterAccountNumber: formData.fromAccount,
      beneficiaryAccountNumber: formData.toAccount,
      transactionMode: formData.transactionMode,
      amount: getCleanedAmount(),
      transactionId: formData.transactionId,
    };

    const response = await fetch(`${BASE_URL}/api/transactions/send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (data.error) {
      setResponseMessage('Transaction failed: ' + data.error);
      setTransactionDetails({
        accountNumber: formData.toAccount,
        availableBalance: data.availableBalance || '',
      });
    } else {
      setResponseMessage(data.message);
      setTransferredAmount(data.amountTransferred);
      setReferenceNumber(data.transactionId); // Use the response data to set reference number
      setTransactionDetails({
        accountNumber: data.accountNumber,
        availableBalance: data.availableBalance,
      });

      // Set the response data for box1 and box2
      setBox1Data({
        tag1: data.tag1,
        account1: data.account1,
        amountTransferred1: data.amountTransferred1,
        tagType1: data.tagType1,
        tagValidity1: data.tagValidity1,
      });

      setBox2Data({
        tag2: data.tag2,
        account2: data.account2,
        amountTransferred2: data.amountTransferred2,
        tagType2: data.tagType2,
        tagValidity2: data.tagValidity2,
      });
      setTransactionSubmitted(true); // Set form as submitted
    }
  } catch (error) {
    console.error('Error sending transaction:', error);
    setResponseMessage('Transaction failed');
  }
};
// Function to submit a transaction
export const submitTransaction2 = async (formData, getCleanedAmount, setResponseMessage, setTransferredAmount, setTransactionDetails, setBox1Data, setBox2Data, setTransactionSubmitted, setReferenceNumber, setTag1Data) => {
  try {
    const payload = {
      remitterAccountNumber: formData.fromAccount,
      beneficiaryAccountNumber: formData.toAccount,
      transactionMode: formData.transactionMode,
      amount: getCleanedAmount(),
      transactionId: formData.transactionId,
    };

    const response = await fetch(`${BASE_URL}/api/transactions/send2`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (data.error) {
      setResponseMessage('Transaction failed: ' + data.error);
      setTransactionDetails({
        accountNumber: formData.toAccount,
        availableBalance: data.availableBalance || '',
      });
    } else {
      setResponseMessage(data.message);
      setTransferredAmount(data.amountTransferred);
      setReferenceNumber(data.transactionId);
      setTransactionDetails({
        accountNumber: data.accountNumber,
        availableBalance: data.availableBalance,
      });

      // Set the response data for box1 and box2
      setBox1Data({
        tag2: data.tag2,
        account2: data.account2,
        amountTransferred2: data.amountTransferred2,
        tagType2: data.tagType2,
        tagValidity2: data.tagValidity2,
      });

      setBox2Data({
        tag3: data.tag3,
        account3: data.account3,
        amountTransferred3: data.amountTransferred3,
        tagType3: data.tagType3,
        tagValidity3: data.tagValidity3,
      });
      // Set tag1 data if it exists in the response
      if (data.tag1) {
        setTag1Data(data.tag1);
      }
      setTransactionSubmitted(true); // Set form as submitted
    }
  } catch (error) {
    console.error('Error sending transaction:', error);
    setResponseMessage('Transaction failed');
  }
};

// Function to handle a withdrawal transaction
export const handleWithdrawal = async (transactionDetails, amount, setTransactionSuccessful, setTransactionMessage, setTransactionDetails) => {
  if (amount) {
    // Convert amount to string if it is not already
    const numericAmount = parseFloat(amount.toString().replace(/,/g, ""));
    const payload = {
      accountNumber: transactionDetails.accountNumber,
      amount: numericAmount,
    };

    try {
      const response = await fetch(`${BASE_URL}/api/transactions/atm/withdraw`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      setTransactionSuccessful(true);
      setTransactionMessage(data.message); // Set the message from the API response
      setTransactionDetails((prevDetails) => ({
        ...prevDetails,
        nonTagAmount: data.nonTagAmount,
        totalTagAmount: data.totalTagAmount,
        availableBalance: data.availableBalance, // Update availableBalance after withdrawal
      }));
    } catch (error) {
      console.error("Error processing withdrawal:", error);
      alert("Failed to process withdrawal.");
    }
  } else {
    alert("Please enter an amount!");
  }
};

// Function to call the failure count API for withdraw13
export const fetchAnother10FailureCountApi = async () => {
  try {
    const requestBody = JSON.stringify({ amount: "10000000" });

    const response = await fetch(`${BASE_URL}/api/transactions/atm/withdraw10`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: requestBody,
    });

    if (!response.ok) {
      throw new Error("Failed to fetch failure count for withdraw10.");
    }

    const data = await response.json();
    return data; // Return the API response data
  } catch (error) {
    console.error("Error fetching failure count for withdraw10:", error);
    throw error; // Re-throw the error for handling in the component
  }
};

// Function to call the failure count API for withdraw13
export const fetchAnother12FailureCountApi = async () => {
  try {
    const requestBody = JSON.stringify({ amount: "10000000" });

    const response = await fetch(`${BASE_URL}/api/transactions/atm/withdraw12`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: requestBody,
    });

    if (!response.ok) {
      throw new Error("Failed to fetch failure count for withdraw13.");
    }

    const data = await response.json();
    return data; // Return the API response data
  } catch (error) {
    console.error("Error fetching failure count for withdraw12:", error);
    throw error; // Re-throw the error for handling in the component
  }
};

// Function to fetch tag1 data
export const fetchTag1Api = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/transactions/tag1`, {
      method: "GET",
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`Error: ${errorData.message || "Unknown error"}`);
    }

    const data = await response.json();
    return data.tag1; // Extracting only the `tag1` value
  } catch (error) {
    console.error("Error fetching tag1:", error);
    throw error;
  }
};

export const handleLoginApi = async (password) => {
  try {
    if (!password) {
      throw new Error("Please enter a password.");
    }

    const response = await fetch(`${BASE_URL}/api/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ password }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(`Error: ${data.message || "Invalid Credentials"}`);
    }

    return data;
  } catch (error) {
    console.error("Error during login:", error);
    throw error;
  }
};